module.exports = __webpack_public_path__ + "static/ywnrh-8deb214444ea19454c497faff7a2ea89.jpg";